import Link from 'components/Globals/Base/Link';
import { MyAccountLinks } from 'constants/constants';
import HEADER_NAVIGATION from 'constants/testsIds/headerNavigation';
import { UserCircle } from 'icons/UserCircle';
import { useState } from 'react';
import logOut from 'services/Piano/logOut';
import * as S from './MyAccountStyles';

export interface MyAccountProps {
  className?: string;
}

const MyAccount = ({ className }: MyAccountProps) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  return (
    <S.MyAccountWrapper
      className={`${className} ${isSubMenuOpen ? 'open' : ''}`}
      data-cy={HEADER_NAVIGATION.MY_ACCOUNT_DROPDOWN}
    >
      <S.UserButton
        type='button'
        onClick={() => setIsSubMenuOpen(!isSubMenuOpen)}
        data-cy='userIconBtn'
      >
        <UserCircle />
      </S.UserButton>

      <S.AccordionWrapper className={isSubMenuOpen ? 'open' : ''}>
        <S.MyAccountLink
          href='/my-account/'
          className='my-account-link'
        >
          My Account
        </S.MyAccountLink>
        <S.Arrow className='arrow' />
      </S.AccordionWrapper>

      <S.SubMenu className='submenu'>
        {MyAccountLinks.map((item) => {
          const trimmedLabel = item.label.trim();
          return (
            <S.SubMenuItem key={item.url}>
              <Link
                href={item.url}
                aria-label={`Navigate to ${trimmedLabel} section of My Account`}
                type='primary'
                hasRightArrow={false}
                data-cy={`my-account-${trimmedLabel.toLowerCase().replace(' ', '-')}-navlink`}
              >
                {trimmedLabel}
              </Link>
            </S.SubMenuItem>
          );
        })}
        <S.SubMenuItem>
          <button
            type='button'
            onClick={logOut}
            data-cy='logoutBtnDesktop'
          >
            Sign Out
          </button>
        </S.SubMenuItem>
      </S.SubMenu>
    </S.MyAccountWrapper>
  );
};

export default MyAccount;
